export const API_KEY = 'aa90bacd4bbbefb3216a88bf4ec87d33'
export const API_URL = `https://api.themoviedb.org/3/movie/upcoming?api_key=${API_KEY}&language=en-US`

/* export const API_URL = `https://api.themoviedb.org/3/movie/popular?api_key=${API_KEY}&language=en-US&page=1` */


